import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { cn as o } from "@tameeni/shared-logic";
import t from "react";
import { HomeSection as d } from "../home-section/home-section.js";
import { Animated as s } from "@tameeni/ui";
function p({ imageSrc: r, alt: i }) {
  return /* @__PURE__ */ n("picture", { children: [
    /* @__PURE__ */ e("source", { media: "(min-width: 1024px)", srcSet: r.desktop }),
    /* @__PURE__ */ e("img", { loading: "lazy", src: r == null ? void 0 : r.mobile, alt: i, className: "w-full" })
  ] });
}
function h(r) {
  return /* @__PURE__ */ e(d, { children: /* @__PURE__ */ e(
    "div",
    {
      className: o(
        r.cols === 1 ? "grid grid-cols-1" : "grid grid-cols-1 md:grid-cols-2 gap-4"
      ),
      children: t.Children.map(r.children, (i, l) => /* @__PURE__ */ e(
        s.SlideIn,
        {
          className: "h-full",
          useScroll: !0,
          transition: { delay: l * 0.3 },
          children: i
        },
        l
      ))
    }
  ) });
}
export {
  p as BannerItem,
  h as default
};
//# sourceMappingURL=index.js.map
